import React from "react";
import "./loader.css";
export default function Loader() {
  return (
    <div className="cus-modal-loaders">
      <div className="loader-alignment br-modal-bg-scroll-set-tab">
        <div class="spinner"></div>
      </div>
    </div>
  );
}
